export class QueriesListModel{
    "siteId":Number;
    "userId":Number;
}